import React, { useCallback, useEffect, useMemo, useState } from "react";
import { reputationClient } from "src/services/requestClient";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";

const ReputationContext = React.createContext({});

export default function ReputationProvider({ children }) {
  const { address } = useWeb3Connect();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [error, setError] = useState(undefined);

  const fetchReputationUser = async () => {
    const res = await reputationClient.get(`/history/${address}`);
    return {
      userRank: res.rank,
      timeDuration: res.time_duration,
      balanceHistory: res.balance_history,
      balanceDetailHistory: res.balance_detail_history,
      rankHistory: res.rank_history,
      ranges: res.ranges,
      travaToken: res.tokens,
    };
  };

  const featReputationSuggestion = async () => {
    const res = await reputationClient.get(`/suggestion/${address}`);
    return { suggestions: res.suggestions };
  };

  const fetchReputationRank = async () => {
    const res = await reputationClient.get("/stats");
    return {
      rank: res.stats,
      totalHolder: res.total_holders,
      tokens: res.tokens,
    };
  };

  const fetchData = useCallback(
    async (withLoading) => {
      withLoading && setLoading(true);
      try {
        const reputationRank = await fetchReputationRank();
        let reputationUser = undefined;
        let reputationSuggestions = undefined;
        if (address) {
          [reputationUser, reputationSuggestions] = await Promise.all([
            fetchReputationUser(address),
            featReputationSuggestion(address),
          ]);
        }
        setData({ reputationUser, reputationSuggestions, reputationRank });
        setError(undefined);
      } catch (error) {
        setError(error);
      }
    },
    [address]
  );

  useEffect(() => {
    fetchData(true);
  }, [address]);

  const contextData = useMemo(() => {
    return {
      loading,
      error,
      ...{
        data: {
          ...data,
        },

        refresh: fetchData,
      },
    };
  }, [loading, error, data, fetchData]);

  return <ReputationContext.Provider value={contextData}>{children}</ReputationContext.Provider>;
}

export const useReputationContext = () => React.useContext(ReputationContext);

export const useReputationSelector = (selectorFn) => {
  const { data } = useReputationContext();

  return useMemo(() => selectorFn(data), [data]);
};
